<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item active">
            Media
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Media

            <router-link
                to="/admin/media/create"
                class="btn btn-success btn-sm float-end"
            >
                Create Media
            </router-link>
        </div>

        <div class="card-body">
            <media-table endpoint="/admin/api/media" />
        </div>

    </div>
</template>

<script>
import MediaTable from "../../../admin/MediaTable.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
  name: "Media",

  components: {
      AdminBreadcrumbs,
    MediaTable,
  },
};
</script>
